
















import { Vue, Component } from 'vue-property-decorator'

@Component
export default class Contact extends Vue {
  private loading = false

  private async sendEmail () {
    const name = this.getInputValue('name')
    const email = this.getInputValue('email')
    const subject = this.getInputValue('subject')
    const message = this.getInputValue('message')

    if (name && email && subject && message) {
      const data = { name, email, subject, message }

      this.loading = true

      try {
        const url = 'https://us-central1-autohaus-eble.cloudfunctions.net/sendMail'
        await this.$http.post(url, data)
        alert('Nachricht wurde erfolgreich versendet!')
        this.clearInputs()
      } catch (error) {
        alert('Die Nachricht konnte leider nicht versendet werden. Bitte versuchen Sie es erneut!')
      }

      this.loading = false
    } else {
      alert('Bitte füllen Sie alle Felder aus!')
    }
  }

  private clearInputs () {
    this.clearInput('name')
    this.clearInput('email')
    this.clearInput('subject')
    this.clearInput('message')
  }

  private clearInput (id: string) {
    const input = document.getElementById(id) as HTMLInputElement
    input.value = ''
  }

  private getInputValue (id: string) {
    const input = document.getElementById(id) as HTMLInputElement

    if (input) {
      return input.value
    }
    return undefined
  }
}
